<script>
    //it says legacy mode in VSO because runes are not needed hence not used

    import { logout } from "../user/service.svelte.js";
    import LocaleChanger from "./_components/localeChanger.svelte";
    import SearchAsset from "./_components/search-asset.svelte";
    import { format, locale } from 'svelte-i18n';
    import { workspacePlan } from "../user/user.state.svelte.js";
    import { isActive } from "@roxi/routify";

    const handleLogout = () => {
        logout(false, "/login");
    };
</script>

<nav class="app-header navbar navbar-expand bg-body">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
        <li class="nav-item">
            <a
                class="nav-link"
                data-lte-toggle="sidebar"
                href="#"
                role="button"
            >
                <i class="fas fa-bars" /></a
            >
        </li>
    </ul>
    {#if workspacePlan.data != "premium" && workspacePlan.data != "aws"}
        <div style="margin-right: 15px;">
            <a href="/plan" target="_blank"
                >{$format("layout.header.upgrade_plan")}</a
            >
        </div>
    {/if}
    <a
        class:docs-width={workspacePlan.data == "premium" ||
            workspacePlan.data == "aws"}
        href={$locale == "es"
            ? "https://doc.vulseek.io/es"
            : "https://doc.vulseek.io/"}
        target="_blank"
        title={$format("layout.header.docs_title")}
        ><i class="fas fa-book"></i></a
    >
    <div class="navbar-search-block navbar-search-open">
        <SearchAsset />
    </div>
    <!-- Right navbar links -->
    <ul class="navbar-nav">
        <LocaleChanger />
        {#if !$isActive("/pentest")}
            <li class="nav-item">
                <a
                    class="btn btn-sm btn-default ms-3 me-3"
                    href="/pentest"
                    style="background: white; border: 1px solid rgb(251, 56, 59); color: rgb(251, 56, 59) !important; line-height: 1.5 !important"
                >
                    {$format("buttons.pentest")}
                </a>
            </li>
        {/if}
        <li class="nav-item">
            <button
                title={$format("logout")}
                class="btn btn-sm btn-default vlsk-bg-red"
                style="line-height: 1.5 !important;"
                onclick={() => handleLogout()}
            >
                {$format("logout")}<i class="fas fa-sign-out-alt ms-1" />
            </button>
        </li>
    </ul>
</nav>

<style>
    .app-header {
        border-bottom: none !important;
        box-shadow: rgba(33, 37, 41, 0.125) 0px 0px 1px 0px, rgba(33, 37, 41, 0.2) 0px 1px 3px 0px !important;
    }
    .navbar-search-block {
        display: flex !important;
        width: 450px;
        position: relative;
        margin: 0 auto;
        left: 3.5em;
    }
    .vlsk-bg-red {
        background-color: rgb(251, 56, 59) !important;
        border-color: rgb(251, 56, 59) !important;
        color: white;
    }
    .docs-width {
        min-width: 163px;
    }
</style>
